module.exports = __webpack_public_path__ + "eb5ef829d502fc08a2211c7a79b1cbf4.svg";